module.exports = __webpack_public_path__ + "static/media/images.62447228.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/temp/images.jpg
// module id = 934
// module chunks = 0